import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./../components/Footer";

const LegalPageLayout = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-white">

      <main className="flex-1 w-full max-w-4xl mx-auto px-6 py-8 text-primary">
        <div className="mb-8">
          <button
            onClick={() => navigate('/app')}
            className="inline-flex items-center text-rose-700 hover:text-rose-800 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to Dashboard
          </button>
        </div>

        <header className="mb-8 border-b border-gray-200 pb-4">
          <h1 className="text-3xl font-bold text-rose-500">{title}</h1>
          <p className="text-sm text-gray-500 mt-2">
            Last Updated: {lastUpdated}
          </p>
        </header>

        <div className="prose prose-rose max-w-none">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalPageLayout;
